import { defineComponent } from 'vue';
import SearchLocationCard from '@/components/Locations/subComponents/SearchLocationCard.vue';
import LocationsByBrowserLocation from '@/components/Locations/subComponents/LocationsByBrowserLocation.vue';
import { mapActions, mapState } from 'vuex';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import { postCodeRequiredRule } from '@/helpers/ValidationRules';
export default defineComponent({
    name: 'location-search-box',
    components: { BaseInput, LocationsByBrowserLocation, SearchLocationCard },
    props: {
        restrictedToRegion: {
            type: Number,
            required: false,
            default: null,
        },
        baseColor: {
            type: String,
            required: false,
            default: '#71b84a',
        },
    },
    data() {
        return {
            searchResults: [],
            searchString: '',
            maxResults: 4,
            searchWithOpeningTimes: true,
            searchRedCategories: true,
        };
    },
    computed: Object.assign({ rule() {
            return postCodeRequiredRule.clone().default('');
        } }, mapState('global', {
        locations: 'locations',
    })),
    methods: Object.assign(Object.assign({}, mapActions('global', {
        searchLocations: 'SEARCH_LOCATIONS',
    })), { zipSearch() {
            this.searchLocations({
                search_string: this.searchString,
                opened_filter: false,
                region_id: this.restrictedToRegion,
                max_results: this.maxResults,
            });
        } }),
});
